import React from 'react'
import { useGlobalState } from '../../../../../hooks/store/useGlobalState'
import { HealthcareService } from '@teschglobal/tg-fhir-react-components'
import type { HealthcareService as FHIRHealthcareService } from '@teschglobal/tg-fhir-react-components/dist/types'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'

type HealthcareServiceDetailProps = {
    service: FHIRHealthcareService | null
}

const HealthcareServiceDetail: React.FC<HealthcareServiceDetailProps> = ({ service }) => {
    const healthcareServiceFromState = useGlobalState(state => state.healthcareService)
    const { providerDirectoryFhirConfig, handleSelectOrganization } = useFhirConfig()

    return (
        <section>
            <h3>HealthcareService</h3>
            <HealthcareService
                data={(service ?? healthcareServiceFromState) || undefined}
                fhirApiConfig={providerDirectoryFhirConfig}
                onSelectOrganization={handleSelectOrganization}
            />
        </section>
    )
}

export default HealthcareServiceDetail